/* eslint-disable prettier/prettier */
import "./EasySoftwareHeroBanner.scss";

import React, { FunctionComponent } from "react";

import EasyDynamicEight from "../EasyDynamicEight/EasyDynamicEight";
import EasySoftwareHeroBannerItemPicture, { EasySoftwareHeroBannerItemPictureType } from "./EasySoftwareHeroBannerItemPicture";
import EasySoftwareHeroBannerItemText, { EasySoftwareHeroBannerItemTextType } from "./EasySoftwareHeroBannerItemText";
import EasySoftwareHeroBannerItemVideo, { EasySoftwareHeroBannerItemVideoType } from "./EasySoftwareHeroBannerItemVideo";

// TODO: contentItems: any
export interface EasySoftwareHeroBannerContainerType {
  pageContentItemId: string
  editorPath: string,
  displayText: string;
  heroBannerContainerTheme: string;
  heroBannerContainerItems: {
    contentItems: [
      EasySoftwareHeroBannerItemPictureType | EasySoftwareHeroBannerItemTextType | EasySoftwareHeroBannerItemVideoType
    ]
  };
}

export type HeroBannerContainerTheme = `HeroBannerContainer--noOverflow` | `HeroBannerContainer--noBackground` | `HeroBannerContainer--gradientBackground`;

const EasySoftwareHeroBannerContainerDecor: FunctionComponent = () => (
  <div className="HeroBannerContainer-decorLayer">
    <EasyDynamicEight
      className="HeroBannerContainer-decor"
      dynamicEightColor="blue"
      dynamicEightPosition="center"
      dynamicEightSize="l"
      dynamicEightFit="height"
      dynamicEightHeight="100%"
      />
  </div>
);

const EasySoftwareHeroBannerContainer: FunctionComponent<EasySoftwareHeroBannerContainerType> = (props) => {
  const isDefaultTheme = !props.heroBannerContainerTheme;
  const showDecor = isDefaultTheme || props.heroBannerContainerTheme === `HeroBannerContainer--noOverflow`;
  const themeClass = props.heroBannerContainerTheme || `HeroBannerContainer--default`;

  return (
    <div className={`HeroBannerContainer EasySoftwareHeroBanner ${themeClass}`}>
      {props.heroBannerContainerItems &&
        props.heroBannerContainerItems.contentItems &&
        props.heroBannerContainerItems.contentItems.map((item: any) => {
          const innerClass = `HeroBannerContainer-inner HeroBannerContainer-inner--${item.contentType.replace(`EasySoftwareHeroBannerItem`, ``)}`;
          switch (item.contentType) {
            case `EasySoftwareHeroBannerItemPicture`:
              return (
                <div className={innerClass}
                  key={item.contentItemId}>
                  {showDecor && <EasySoftwareHeroBannerContainerDecor />}
                  <EasySoftwareHeroBannerItemPicture
                    data={item}
                    key={item.contentItemId}
                    pageContentItemId={props.pageContentItemId}
                    editorPath={props.editorPath + `,heroBannerContainerItems,contentItems,cid-${item.contentItemId},easySoftwareHeroBannerItemPicture,heroBannerItemPictureContent,html`}
                  />
                </div>
              );
            case `EasySoftwareHeroBannerItemVideo`:
              return (
                <div className={innerClass}
                  key={item.contentItemId}>
                  {showDecor && <EasySoftwareHeroBannerContainerDecor />}
                  <EasySoftwareHeroBannerItemVideo
                    data={item}
                    key={item.contentItemId}
                    pageContentItemId={props.pageContentItemId}
                    editorPath={props.editorPath + `,heroBannerContainerItems,contentItems,cid-${item.contentItemId},easySoftwareHeroBannerItemVideo,heroBannerItemVideoContent,html`}
                  />
                </div>
              );
            case `EasySoftwareHeroBannerItemText`:
              return (
                <div className={innerClass}
                  key={item.contentItemId}>
                  {showDecor && <EasySoftwareHeroBannerContainerDecor />}
                  <EasySoftwareHeroBannerItemText
                    data={item}
                    key={item.contentItemId}
                    pageContentItemId={props.pageContentItemId}
                    editorPath={props.editorPath + `,heroBannerContainerItems,contentItems,cid-${item.contentItemId},easySoftwareHeroBannerItemText,heroBannerItemTextContent,html`}
                  />
                </div>
              );

            default:
              return ``;
          }
        })}


    </div>
  )
};

export default EasySoftwareHeroBannerContainer;
